module.exports = __webpack_public_path__ + "newsTitle.e7bc1621.png";